

















import { Component, Vue } from 'vue-property-decorator';
import Study from '@/study/Study';
import SearchIcon from '@/assets/icons/search.svg';
import SearchResultItem from '@/components/search/SearchResultItem.vue';

@Component({
    components: {
        SearchIcon,
        SearchResultItem,
    },
})
export default class SearchPanel extends Vue {
    query = '';

    private get studies(): Array<Study> {
        const studies = Study.query()
            .with('location')
            .search(this.query, {
                threshold: 0.3,
                keys: ['name'],
            })
            .get();

        return studies;
    }
}
